import axios from 'axios'
import config from '../config/config'
import router from '@/router'

const serverRoot = config.serverRoot
var ajax = axios.create({
  baseURL: config.serverRoot,
  timeout: 600000,
  // headers: {'Cookie': document.cookie}
})
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
axios.defaults.withCredentials = true
// Add a request interceptor
ajax.interceptors.request.use(function (config) {
  config.url = config.url.replace(serverRoot + '@/', '')
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

axios.interceptors.response.use(function (response) {
  if (response.status === 500) {
    // router.push('/500')
  }
  return response
}, function (error) {
  return Promise.reject(error)
})
export default ajax



// WEBPACK FOOTER //
// ./src/http/index.js